module.exports = "/static/Images/es/negative.png";